import { useSelector } from 'react-redux';
/** Represents a typed selector hook. */
export const useAppSelector = useSelector;
